(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kc-cinematic-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kc-cinematic-hero')) {
    class KcCinematicHero extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.canvas = this.querySelector('canvas');
        this.visible = true;
        this.elapsed = 0;
        this.lastTick = 0;
        this.pointer = [0.65, 0.5];
        this.target = [0.65, 0.5];
        this.tick = this.tick.bind(this);
        const options = { signal: this.controller.signal };
        this.addEventListener('pointermove', (event) => {
          if (event.pointerType !== 'mouse' || this.motion.matches) return;
          const rect = this.getBoundingClientRect();
          this.target = [(event.clientX - rect.left) / rect.width, 1 - (event.clientY - rect.top) / rect.height];
          this.style.setProperty('--kc-pointer-x', `${(this.target[0] - .5) * -13.8}px`);
          this.style.setProperty('--kc-pointer-y', `${(this.target[1] - .5) * 9.2}px`);
        }, options);
        this.addEventListener('pointerleave', () => {
          this.target = [.65, .5];
          this.style.setProperty('--kc-pointer-x', '0px');
          this.style.setProperty('--kc-pointer-y', '0px');
        }, options);
        this.motion.addEventListener('change', () => this.sync(), options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.canvas.addEventListener('webglcontextlost', (event) => {
          event.preventDefault();
          cancelAnimationFrame(this.frame);
          this.gl = null;
          this.canvas.hidden = true;
        }, options);
        const photo = this.querySelector('.kc-cinema__image');
        const startScene = () => {
          this.startFrame = requestAnimationFrame(() => {
            this.startFrame = requestAnimationFrame(() => {
              if (!this.isConnected || this.controller.signal.aborted) return;
              this.setupScene();
              this.resizeObserver = new ResizeObserver(() => this.resize());
              this.resizeObserver.observe(this);
              this.resize();
              this.sync();
            });
          });
        };
        if (photo && typeof photo.decode === 'function') {
          photo.decode().catch(() => {}).then(startScene);
        } else if (photo && !photo.complete) {
          photo.addEventListener('load', startScene, { once: true, signal: this.controller.signal });
          photo.addEventListener('error', startScene, { once: true, signal: this.controller.signal });
        } else {
          startScene();
        }
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.sync();
        });
        this.visibilityObserver.observe(this);
        this.resize();
        this.sync();
      }
      setupScene() {
        const gl = this.canvas.getContext('webgl', { alpha: true, antialias: false, depth: false, powerPreference: 'low-power' });
        if (!gl) return;
        const vertex = 'attribute vec2 a; varying vec2 uv; void main(){ uv=a*.5+.5; gl_Position=vec4(a,0.,1.); }';
        const fragment = `precision mediump float;
          varying vec2 uv;
          uniform float time;
          uniform float aspect;
          uniform float variant;
          uniform vec2 pointer;
          float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}
          float noise(vec2 p){vec2 i=floor(p); vec2 f=fract(p); f=f*f*(3.-2.*f); return mix(mix(hash(i),hash(i+vec2(1.,0.)),f.x),mix(hash(i+vec2(0.,1.)),hash(i+vec2(1.,1.)),f.x),f.y);}
          float fbm(vec2 p){float v=0.; float w=.5; for(int i=0;i<4;i++){v+=w*noise(p);p=p*2.03+vec2(1.3,4.7);w*=.5;}return v;}
          void main(){
            vec2 p=vec2(uv.x*aspect,uv.y);
            float t=time*(aspect<.8?.38:.28);
            p+=vec2(-t*.20,t*.13);
            vec2 q=vec2(fbm(p*2.3+vec2(t*.45,-t*.7)),fbm(p*2.8+vec2(-t*.2,t*.5)+3.1));
            float silk=fbm(p*3.6+q*3.0+vec2(-t*.35,t*.6));
            float folds=pow(max(0.,sin((silk+uv.y*.18)*15.+t*.4)),6.);
            float cloud=smoothstep(.32,.77,silk);
            float zone=smoothstep(.14,.62,uv.x)*(1.-smoothstep(.72,1.,uv.y));
            float cursor=exp(-length((uv-pointer)*vec2(aspect,1.))*3.5);
            float opacity=zone*(cloud*.6+folds*.21)*(0.65+cursor*.65);
            vec3 red=mix(vec3(.25,.006,.013),vec3(.68,.04,.048),folds*.6+cursor*.2);
            if(variant>.5){
              float curve=.29+.24*uv.x+.14*sin(uv.x*4.8-time*.38)+.045*sin(uv.x*10.+time*.55);
              float distance=uv.y-curve;
              float ribbon=1.-smoothstep(.075,.14,abs(distance));
              float trailing=exp(-pow(distance+.19+.05*sin(uv.x*8.-t),2.)*240.);
              float weave=.5+.5*sin(distance*47.+uv.x*7.-time*.8+q.x*2.);
              float ridge=pow(weave,5.);
              opacity=min(.94,(ribbon*.88+trailing*.26)*smoothstep(.12,.62,uv.x));
              red=mix(vec3(.12,.002,.005),vec3(.64,.032,.04),weave*.72+ridge*.28);
              red+=vec3(.11,.006,.006)*ridge;
            }
            gl_FragColor=vec4(red*opacity,opacity);
          }`;
        const compile = (type, source) => {
          const shader = gl.createShader(type);
          gl.shaderSource(shader, source);
          gl.compileShader(shader);
          if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) { gl.deleteShader(shader); return null; }
          return shader;
        };
        const vs = compile(gl.VERTEX_SHADER, vertex);
        const fs = compile(gl.FRAGMENT_SHADER, fragment);
        if (!vs || !fs) { if (vs) gl.deleteShader(vs); if (fs) gl.deleteShader(fs); return; }
        const program = gl.createProgram();
        gl.attachShader(program, vs); gl.attachShader(program, fs); gl.linkProgram(program);
        gl.deleteShader(vs); gl.deleteShader(fs);
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) { gl.deleteProgram(program); return; }
        gl.useProgram(program);
        const buffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1,1,-1,-1,1,-1,1,1,-1,1,1]), gl.STATIC_DRAW);
        const location = gl.getAttribLocation(program, 'a');
        gl.enableVertexAttribArray(location);
        gl.vertexAttribPointer(location, 2, gl.FLOAT, false, 0, 0);
        this.gl = gl; this.program = program; this.buffer = buffer;
        this.uniforms = { time: gl.getUniformLocation(program, 'time'), aspect: gl.getUniformLocation(program, 'aspect'), pointer: gl.getUniformLocation(program, 'pointer'), variant: gl.getUniformLocation(program, 'variant') };
        this.setAttribute('data-scene', 'ready');
      }
      resize() {
        if (!this.gl) return;
        const rect = this.getBoundingClientRect();
        const pixelBudget = rect.width < 768 ? 120000 : 260000;
        const scale = Math.min(1, 1000 / rect.width, 650 / rect.height, Math.sqrt(pixelBudget / Math.max(1, rect.width * rect.height)));
        this.canvas.width = Math.max(1, Math.round(rect.width * scale));
        this.canvas.height = Math.max(1, Math.round(rect.height * scale));
        this.gl.viewport(0, 0, this.canvas.width, this.canvas.height);
        this.draw();
      }
      draw() {
        if (!this.gl) return;
        this.gl.uniform1f(this.uniforms.time, this.elapsed);
        this.gl.uniform1f(this.uniforms.aspect, this.canvas.width / this.canvas.height);
        this.gl.uniform1f(this.uniforms.variant, this.dataset.atmosphere === 'silk' ? 1 : 0);
        this.gl.uniform2f(this.uniforms.pointer, this.pointer[0], this.pointer[1]);
        this.gl.drawArrays(this.gl.TRIANGLES, 0, 6);
      }
      sync() {
        cancelAnimationFrame(this.frame);
        this.running = !this.motion.matches && this.visible && !document.hidden;
        this.setAttribute('data-paused', String(!this.running));
        this.lastTick = 0;
        if (this.running && this.gl) this.frame = requestAnimationFrame(this.tick);
      }
      tick(now) {
        if (!this.running || !this.gl) return;
        if (!this.lastTick) this.lastTick = now;
        const delta = now - this.lastTick;
        if (delta >= 32) {
          this.elapsed += Math.min(delta / 1000, .1);
          this.lastTick = now;
          this.pointer[0] += (this.target[0] - this.pointer[0]) * .045;
          this.pointer[1] += (this.target[1] - this.pointer[1]) * .045;
          this.draw();
        }
        this.frame = requestAnimationFrame(this.tick);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        if (this.gl) { this.gl.deleteBuffer(this.buffer); this.gl.deleteProgram(this.program); }
      }
    }
    customElements.define('kc-cinematic-hero', KcCinematicHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-store-reviews"] && !Shopify.designMode) return;
  try {
    
  function kcWaitForReviewReady(check) {
    return new Promise((resolve, reject) => {
      const start = Date.now();
      function inspect() {
        if (check()) return resolve();
        if (Date.now() - start > 15000) return reject(new Error('Reviews could not finish loading'));
        setTimeout(inspect, 100);
      }
      inspect();
    });
  }

  async function kcLoadOpenReviews(details) {
    const template = details.querySelector('[data-kc-review-template]');
    if (!details.open || !template || details.dataset.kcReviewState) return;
    details.dataset.kcReviewState = 'loading';
    const mount = details.querySelector('[data-kc-review-mount]');
    const status = details.querySelector('.kc-store-reviews__status');
    const fallback = details.querySelector('.kc-store-reviews__fallback');
    status.hidden = false;
    mount.setAttribute('aria-busy', 'true');
    mount.style.visibility = 'hidden';
    try {
      await kcWaitForReviewReady(() => typeof window.jdgm?.loadScript === 'function' && typeof window.jdgm?.widgetPath === 'function');
      const legacy = template.content.querySelector('.jdgm-all-reviews-widget');
      if (!legacy || window.jdgmSettings?.all_reviews_widget_v2025_enabled) throw new Error('Reviews widget requires its full page');
      mount.append(template.content.cloneNode(true));
      mount.querySelectorAll('.jdgm-legacy-widget-content').forEach(element => { element.style.display = ''; });
      mount.querySelectorAll('.jdgm-ssr-reviews').forEach(element => element.remove());
      const jdgm = window.jdgm;
      jdgm.loadCSS(jdgm.widgetPath('base.css'));
      jdgm.loadCSS(jdgm.widgetPath('main.css'), () => {
        document.dispatchEvent(new Event('jdgm.doneLoadingCss', { bubbles: true }));
      });
      jdgm.loadScript('widget/base.js');
      await kcWaitForReviewReady(() => !!jdgm.$ && !!jdgm.DONE_SETUP_WIDGET_CLASS);
      jdgm.loadScript('widget/common.js');
      await kcWaitForReviewReady(() => typeof jdgm.customizeReviews === 'function' && !!jdgm.caches);
      jdgm.loadScript('widget/arp.js');
      await kcWaitForReviewReady(() => typeof jdgm.AllReviewsPage === 'function' && !!mount.querySelector('.jdgm-all-reviews__footer'));
      details.dataset.kcReviewState = 'ready';
      template.remove();
      mount.style.visibility = '';
      kcRefreshOpenReviews(details);
    } catch (error) {
      details.dataset.kcReviewState = 'error';
      mount.hidden = true;
      fallback.hidden = false;
    } finally {
      status.hidden = true;
      mount.removeAttribute('aria-busy');
    }
  }

  function kcRefreshOpenReviews(details) {
    if (details.open) {
      requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
    }
  }

  function kcBindReviewDisclosure() {
    const details = document.getElementById('kc-custom-store-reviews');
    if (!details || details.dataset.kcDisclosureReady) return;
    details.dataset.kcDisclosureReady = 'true';
    details.addEventListener('toggle', () => {
      kcLoadOpenReviews(details);
      if (details.dataset.kcReviewState !== 'loading') kcRefreshOpenReviews(details);
    });
    if (window.location.hash === '#kc-custom-store-reviews') details.open = true;
    if (details.open) kcLoadOpenReviews(details);
  }

  kcBindReviewDisclosure();
  document.addEventListener('DOMContentLoaded', kcBindReviewDisclosure);
  document.addEventListener('shopify:section:load', kcBindReviewDisclosure);
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-kc-store-reviews-link]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const details = document.getElementById('kc-custom-store-reviews');
    if (!details) return;
    event.preventDefault();
    details.open = true;
    requestAnimationFrame(() => {
      document.getElementById('kc-custom-store-reviews-summary')?.focus({ preventScroll: true });
      details.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      kcRefreshOpenReviews(details);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
